<template>
  <el-container direction="vertical">
    <el-header>
      <Header />
    </el-header>
    <el-main>
      <router-view></router-view>
    </el-main>
    <el-footer>
      <Footer />
    </el-footer>
    <div class="floating-sidebar">
      <div class="flow-contact-item qr-code">
        <img src="@/assets/qrcode.jpg" alt="微信二维码">
        <p>微信二维码</p>
      </div>
      <div class="flow-contact-item phone">
        <a href="tel:13646228079" class="phone-link">
          <el-icon><Phone /></el-icon>
          <span>13646228079</span>
        </a>
      </div>
    </div>
  </el-container>
</template>

<script setup>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import { Phone } from '@element-plus/icons-vue'

</script>

<style>
body {
  margin: 0;
  padding: 0;
  font-family: "Cardo", "Times New Roman", Times, serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
}
h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
    margin-bottom: 0.5rem;
    font-family: "Montserrat", sans-serif;
    font-weight: 700;
    line-height: 1.44;
    color: inherit;
    text-transform: uppercase;
    letter-spacing: 0.2em;
}

#app {
  font-family: "Microsoft YaHei", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: auto !important;
  padding: 0 !important;
}

.el-main {
  /* margin-top: 60px; */
  min-height: calc(100vh - 60px - 200px);
  --el-main-padding: 0 !important;
  padding: 0;
}

.el-footer {
  height: auto !important;
  padding: 0 !important;
}

.floating-sidebar {
  position: fixed;
  right: 20px;
  bottom: 100px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.flow-contact-item {
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 15px;
  transition: all 0.3s ease;
}

.flow-contact-item:hover {
  transform: translateX(-5px);
}

.qr-code {
  width: 120px;
}

.qr-code img {
  width: 100%;
  height: auto;
}

.qr-code p {
  margin: 5px 0 0;
  font-size: 14px;
  color: #666;
  text-align: center;
}

.phone {
  padding: 10px 15px;
}

.phone-link {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: #eaad35;
  font-size: 16px;
  font-weight: bold;
}

.phone-link:hover {
  color: #d69a22;
}

/* 响应式布局 */
@media screen and (max-width: 1024px) {
  .floating-sidebar {
    right: 10px;
    bottom: 80px;
  }

  .qr-code {
    width: 100px;
  }

  .phone {
    padding: 8px 12px;
  }
}

@media screen and (max-width: 768px) {
  .floating-sidebar {
    display: flex;
    flex-direction: row;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    padding: 10px;
    gap: 10px;
    justify-content: space-around;
    z-index: 1000;
  }

  .flow-contact-item {
    box-shadow: none;
    padding: 8px;
    flex: 1;
  }

  .flow-contact-item:hover {
    transform: none;
  }

  .qr-code {
    width: auto;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .qr-code img {
    width: 32px;
    height: 32px;
  }

  .qr-code p {
    margin: 0;
    font-size: 12px;
    white-space: nowrap;
  }

  .phone {
    padding: 8px;
  }

  .phone-link {
    justify-content: center;
    font-size: 14px;
  }

  /* 为底部内容添加边距，防止被固定栏遮挡 */
  .el-footer {
    margin-bottom: 60px;
  }
}
</style>

<script>

 export default {
  name: 'App',
  components: {
    // HelloWorld
  }
}


</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.el-footer {
  --el-footer-padding: 0px !important;
}
</style>
